export const GuestsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none">
      <path
        d="M16.3334 9.6665C17.3845 10.1847 18.2858 11.0163 18.9436 12.0562C19.0738 12.2621 19.139 12.3651 19.1615 12.5077C19.2073 12.7974 19.0054 13.1537 18.7304 13.2683C18.595 13.3248 18.4428 13.3248 18.1384 13.3248"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0428 6.87681C11.8372 6.87681 13.2919 5.44931 13.2919 3.68841C13.2919 1.9275 11.8372 0.5 10.0428 0.5C8.24844 0.5 6.79381 1.9275 6.79381 3.68841C6.79381 5.44931 8.24844 6.87681 10.0428 6.87681Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0428 9.00242C7.9991 9.00242 6.18266 10.0968 5.03156 11.7929C4.77938 12.1644 4.6533 12.3502 4.66781 12.5875C4.67912 12.7723 4.80255 12.9985 4.95301 13.1102C5.14625 13.2536 5.41201 13.2536 5.94354 13.2536H14.1421C14.6737 13.2536 14.9394 13.2536 15.1327 13.1102C15.2831 12.9985 15.4065 12.7723 15.4179 12.5875C15.4324 12.3502 15.3063 12.1644 15.0541 11.7929C13.903 10.0968 12.0866 9.00242 10.0428 9.00242Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 7.78261C16.8207 7.78261 17.8913 6.71199 17.8913 5.3913C17.8913 4.07062 16.8207 3 15.5 3"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.3347 9.59521C2.28353 10.1134 1.3823 10.945 0.724474 11.9849C0.594205 12.1909 0.529071 12.2938 0.50655 12.4364C0.460786 12.7262 0.662695 13.0824 0.937685 13.197C1.07301 13.2535 1.22523 13.2535 1.52968 13.2535"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.48552 7.67372C3.16483 7.67372 2.09421 6.6031 2.09421 5.28242C2.09421 3.96174 3.16483 2.89111 4.48552 2.89111"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
